import SmartImage from "./SmartImage";

const PLACEHOLDER = [
    "https://images.unsplash.com/photo-1700448293876-07dca826c161?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1602663491496-73f07481dbea?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1517427294546-5aa121f68e8a?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1604702389032-28cff7432c48?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1629576690723-bb3a22ae7126?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1659401083689-240a4f511a76?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1655762755958-cc0e10095c24?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1700448293876-07dca826c161?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
];

export default function InstagramFeed({ images = PLACEHOLDER }) {
    return (
        <div className="grid grid-cols-3 md:grid-cols-6 lg:grid-cols-9 gap-1 md:gap-2" data-testid="instagram-feed">
            {images.slice(0, 9).map((src, i) => (
                <a
                    key={i}
                    href="https://instagram.com/cakecentral"
                    target="_blank"
                    rel="noreferrer"
                    className="block aspect-square overflow-hidden group relative"
                    data-testid={`instagram-feed-item-${i}`}
                >
                    <SmartImage
                        src={src}
                        alt={`Instagram ${i + 1}`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                    />
                    <div className="absolute inset-0 bg-blush/0 group-hover:bg-blush/20 transition-colors duration-300" />
                </a>
            ))}
        </div>
    );
}
